import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LandingClientService } from "src/app/common/services/landing-page.client";
import { StorageService } from "src/app/common/services/storage.service";
import { LongTermCareManagementDetails } from "src/app/common/interfaces/home/long-term-care-management.interface";
import { DropdownComponent } from "src/app/common/components/core/dropdown/dropdown.component";
import { LTCDatesOptions } from "src/app/common/enums/LTC-dates-options.enum";
import { distinctUntilChanged, Subscription } from "rxjs";

@Component({
  selector: "app-ltc-management",
  standalone: true,
  imports: [CommonModule, DropdownComponent],
  templateUrl: "./ltc-management.component.html",
  styleUrls: ["./ltc-management.component.scss"],
})
export class LtcManagementComponent implements OnInit {
  details?: LongTermCareManagementDetails;
  datesOptions = [
    { name: "Year To Day", id: LTCDatesOptions.ThisYear },
    { name: "This Month", id: LTCDatesOptions.ThisMonth },
    { name: "Last Month", id: LTCDatesOptions.LastMonth },
  ];
  selectedOption = 1;
  displayValueForUnitsPerVisist = 0;
  facilityId!: string | null;
  private facilitySubscription: Subscription | null = null;
  constructor(
    private landingClientService: LandingClientService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.facilityId = this.storageService.getSelectedFacilityId();
    this.getLongTermCareManagementDetails();
    this.facilitySubscription =
      this.storageService.isSelectedFacility.pipe(distinctUntilChanged()).subscribe((facilityId) => {
        this.facilityId = facilityId;
        this.getLongTermCareManagementDetails();
      });
  }

  ngOnDestroy() {
    this.facilitySubscription?.unsubscribe();
  }

  getLongTermCareManagementDetails() {
    if (this.facilityId === null) {
      return;
    }
    this.landingClientService
      .getLongTermCareManagementDetails(this.facilityId)
      .subscribe((response: LongTermCareManagementDetails) => {
        this.details = response;
        this.displayValueForUnitsPerVisist =
          this.details?.unitsPerVisitAverageCurrentYear ?? 0;
      });
  }

  onValueChange(event: any) {
    this.selectedOption = event.value;
    switch (this.selectedOption) {
      case LTCDatesOptions.ThisYear:
        this.displayValueForUnitsPerVisist =
          this.details?.unitsPerVisitAverageCurrentYear ?? 0;
        break;
      case LTCDatesOptions.ThisMonth:
        this.displayValueForUnitsPerVisist =
          this.details?.unitsPerVisitAverageCurrentMonth ?? 0;
        break;
      case LTCDatesOptions.LastMonth:
        this.displayValueForUnitsPerVisist =
          this.details?.unitsPerVisitAverageLastMonth ?? 0;
        break;
    }
  }
}
